// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Fixed_wrapper__Xr88I","content":"Fixed_content__1n3HA"};